import { INotification, notificationRoleScope } from '@/api/notifications/types';
import { UserRole } from '@/stores/slices/selected-user-config';

export const isNotificationForActiveSession = (
  notification: Pick<INotification, 'roleScope' | 'entityId'>,
  role: UserRole,
  entityId: string | null,
): boolean => {
  switch (role) {
    case 'user':
      return notification.roleScope === notificationRoleScope.USER;
    case 'admin':
      return notification.roleScope === notificationRoleScope.GAMMA_ADMIN;
    case 'entity':
      return (
        notification.roleScope === notificationRoleScope.ENTITY_MEMBER &&
        !!entityId &&
        notification.entityId === entityId
      );
    default:
      return false;
  }
};
